// FontAwesomeLoader.js
import { useEffect } from 'react';

const FontAwesomeLoader = () => {
  useEffect(() => {
    const linkId = 'font-awesome-css';
    if (!document.getElementById(linkId)) {
      const link = document.createElement('link');
      link.id = linkId;
      link.rel = 'stylesheet';
      link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css';
      link.crossOrigin = 'anonymous';
      link.referrerPolicy = 'no-referrer';
      // non-blocking trick
      link.media = 'print';
      link.onload = () => { link.media = 'all'; };
      document.head.appendChild(link);
    }
  }, []);

  return null; // This component renders nothing
};

export default FontAwesomeLoader;